import { storeCreator } from '@/utils/store/store.utils';

interface State {
  planId?: string;
  planName?: string;
  isHsaAccount?: boolean;
  terminationStatus?: string;

  handleSetIsHsaAccount: (value?: boolean) => void;
  handleSetPlanName: (value?: string) => void;
  handleSetPlanId: (value?: string) => void;
  handleSetTerminationStatus: (value?: string) => void;
  handleReset: () => void;
}

export const useStore = storeCreator<State>((set) => ({
  planId: undefined,
  planName: undefined,
  terminationStatus: undefined,
  isHsaAccount: false,

  handleSetPlanId: (value) => set((state) => ({
    ...state,
    planId: value,
  })),

  handleSetPlanName: (value) => set((state) => ({
    ...state,
    planName: value,
  })),

  handleSetTerminationStatus: (value) => set((state) => ({
    ...state,
    terminationStatus: value,
  })),

  handleSetIsHsaAccount: (value) => set((state) => ({
    ...state,
    isHsaAccount: value,
  })),

  handleReset: () => set((state) => ({
    ...state,
    planId: undefined,
    planName: undefined,
    terminationStatus: undefined,
    isHsaAccount: false,
  })),
}));